var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { E_INFO_MESSAGE_SEVERITY, InfoMessage } from 'src/ui/components/InfoMessage/InfoMessage';
import { SuccessfulImport } from 'src/ui/views/users/components/UsersImportModal/components/SuccessfulImport/SuccessfulImport';
import { PartialSuccessImport } from 'src/ui/views/users/components/UsersImportModal/components/PartialSuccessImport/PartialSuccessImport';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var UsersImported = function (props) {
    var i18n = props.i18n, result = props.result, onDownloadErrorCsv = props.onDownloadErrorCsv;
    var _a = result || {}, isError = _a.isError, nbOfUsers = _a.nbOfUsers, nbOfCreatedUsers = _a.nbOfCreatedUsers, nbOfUpdatedUsers = _a.nbOfUpdatedUsers, globalMessages = _a.globalMessages, info = _a.info;
    // call error
    if (isError) {
        var unknownErrorText = getPropsByKeyPath(i18n, 'components.importUsersModal.results.failure.unknownError');
        return _jsx(InfoMessage, { severity: E_INFO_MESSAGE_SEVERITY.ERROR, messages: unknownErrorText });
    }
    var nbOfUsersProcessed = nbOfCreatedUsers + nbOfUpdatedUsers;
    var isSuccess = nbOfUsers > 0 && nbOfUsers === nbOfUsersProcessed;
    var isPartialSuccess = nbOfUsersProcessed > 0;
    if (isSuccess) {
        return (_jsx(SuccessfulImport, { i18n: i18n, info: info, nbOfUsers: nbOfUsers, nbOfCreatedUsers: nbOfCreatedUsers, nbOfUpdatedUsers: nbOfUpdatedUsers, globalMessages: globalMessages }));
    }
    else if (isPartialSuccess) {
        return (_jsx(PartialSuccessImport, { i18n: i18n, nbOfUsers: nbOfUsers, nbOfCreatedUsers: nbOfCreatedUsers, nbOfUpdatedUsers: nbOfUpdatedUsers, globalMessages: globalMessages, info: info, onDownloadErrorCsv: onDownloadErrorCsv }));
    }
    else {
        var failureTitle = getPropsByKeyPath(i18n, 'components.importUsersModal.results.failure.mainMessage');
        var failureDetailsText = getPropsByKeyPath(i18n, 'components.importUsersModal.results.failure.details');
        return (_jsx(InfoMessage, __assign({ severity: E_INFO_MESSAGE_SEVERITY.ERROR }, { children: _jsxs("p", { children: [_jsx("b", { children: failureTitle }), _jsx("br", {}), _jsx("br", {}), failureDetailsText] }) })));
    }
};
